import React from 'react'
import './wholesaler.css'
import WholesalerApp from './Wholesaler.jsx'
import PropTypes from 'prop-types'

export const Wholesaler = ({ component }) => {
  const parameters = component.getParameters()
  const backgroundColor = parameters.backgroundColor
  return (
    <div className="Wholesaler">
      <WholesalerApp backgroundColor={backgroundColor}></WholesalerApp>
    </div>
  )
}
Wholesaler.propTypes = {
  component: PropTypes.shape({
    getParameters: PropTypes.func,
  }),
}
